import FilePickerViewState from '../store/schema/FilePickerViewState';
import clearSelectedFileProviderItems from './clearSelectedFileProviderItems';
import { action } from 'satcheljs/lib/legacy';

export default action('clearFileProviderItems')(function clearFileProviderItems(
    viewState: FilePickerViewState
) {
    viewState.fileProviderItems = [];
    viewState.totalItemsCount = 0;

    clearSelectedFileProviderItems(viewState);
});
